import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import NopePrimitive from './NopePrimitive';
import NopeReference from './NopeReference';

var NopeDate = /*#__PURE__*/function (_NopePrimitive) {
  _inherits(NopeDate, _NopePrimitive);

  var _super = _createSuper(NopeDate);

  function NopeDate() {
    var _this;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'The field is not a valid date';

    _classCallCheck(this, NopeDate);

    _this = _super.call(this);
    _this._type = 'object';
    _this.message = message;
    return _this;
  }

  _createClass(NopeDate, [{
    key: "before",
    value: function before(beforeDate) {
      var _this2 = this;

      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Date must be before ".concat(beforeDate.toString());

      var rule = function rule(entry, context) {
        if (_this2.isEmpty(entry)) {
          return;
        }

        var resolvedBeforeDate = beforeDate instanceof NopeReference && context ? context[beforeDate.key] : beforeDate;

        if (entry >= new Date(resolvedBeforeDate)) {
          return message;
        }
      };

      return this.test(rule);
    }
  }, {
    key: "after",
    value: function after(afterDate) {
      var _this3 = this;

      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Date must be after ".concat(afterDate);

      var rule = function rule(entry, context) {
        if (_this3.isEmpty(entry)) {
          return;
        }

        var resolvedAfterDate = afterDate instanceof NopeReference && context ? context[afterDate.key] : afterDate;

        if (entry <= new Date(resolvedAfterDate)) {
          return message;
        }
      };

      return this.test(rule);
    }
  }, {
    key: "validate",
    value: function validate(entry, context) {
      var value = entry;

      if (this.isEmpty(entry) || entry instanceof Date) {
        value = entry;
      } else if (!isNaN(entry)) {
        value = new Date(entry);
      } else {
        var ms = Date.parse(entry);
        if (isNaN(ms)) return this.message;
        value = new Date(ms);
      }

      return _get(_getPrototypeOf(NopeDate.prototype), "validate", this).call(this, value, context);
    }
  }]);

  return NopeDate;
}(NopePrimitive);

export default NopeDate;